import React from 'react';

import { CalendarDefaultSettings } from './calendar-default-settings';
import { CalendarExternalConnectionsList } from './calendar-external-connections-list';
import { CalendarSyncOptionsList } from './calendar-sync-options-list';
import * as Styled from './external-calendar-list.style';

export const ExternalCalendarList: React.FC = () => (
  <Styled.Sections>
    <CalendarExternalConnectionsList />
    <CalendarDefaultSettings />
    <CalendarSyncOptionsList />
  </Styled.Sections>
);
